var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPipelineAssess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 52.3823L45.9905 44.3768C48.1876 41.8185 49.5225 38.502 49.5225 34.8727C49.5225 26.8087 42.9582 20.2477 34.8902 20.2477C26.8222 20.2477 20.2579 26.8087 20.2579 34.8727C20.2579 42.9367 26.8222 49.4978 34.8902 49.4978C38.519 49.4978 41.8372 48.1613 44.3989 45.9675L52.4085 53.973L54 52.3823ZM34.8924 47.25C28.0648 47.25 22.5113 41.697 22.5113 34.875C22.5113 28.053 28.0648 22.5 34.8924 22.5C41.7201 22.5 47.2736 28.053 47.2736 34.875C47.2736 41.697 41.7201 47.25 34.8924 47.25ZM15.7579 13.5H9.0045V11.25H15.7579V13.5ZM9.0045 33.75H15.7579V36H9.0045V33.75ZM20.2601 13.5V11.25H36.018V13.5H20.2601ZM15.7579 24.75H9.0045V22.5H15.7579V24.75ZM41.5108 30.4852L43.0888 32.0895L35.3067 39.7372C34.8182 40.2277 34.1586 40.5 33.4562 40.5C32.7539 40.5 32.0965 40.2278 31.599 39.7305L27.4322 35.694L28.999 34.0763L33.1771 38.1262C33.3167 38.2657 33.5958 38.2658 33.7196 38.1398L41.5085 30.4852H41.5108ZM34.8024 53.9955L18.009 53.991V54H0V5.62725C0 2.5245 2.52351 0 5.62781 0H39.3947C42.4967 0 45.0225 2.52 45.0225 5.62275V13.4977V18.6682C44.3022 18.2183 43.5525 17.811 42.7714 17.4578V5.625C42.7714 3.76425 41.2564 2.25 39.3947 2.25H5.62781C3.76613 2.25 2.25113 3.7665 2.25113 5.62725V51.75H25.8947C28.5533 53.1698 31.5833 53.9798 34.8024 53.9955Z",
    fill: "#0073FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelineAssess);
export default __webpack_public_path__ + "static/media/pipeline-assess.f3019a15fc216262997eb489350b1f4f.svg";
export { ForwardRef as ReactComponent };